import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Banner from '../../../components/Banner';
import Reaction from '../../../components/Reaction';
import Contact from '../../../components/Contact';
import LastUpdate from '../../../components/LastUpdate';

import DeailPayment1 from '../../../local-assets/faq-detail/detail-payment-v1.png';
import DeailPayment2 from '../../../local-assets/faq-detail/detail-payment-v2.png';
import DeailPayment3 from '../../../local-assets/faq-detail/detail-payment-v3.png';
import DeailPayment4 from '../../../local-assets/faq-detail/detail-payment-v4.png';

const Index = () => {
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const renderContent = (title, subTitle, content, srcImg) => (
    <div className="flex flex-col md:flex-row gap-8 md:gap-12">
      
      {/* Kolom Kiri: Teks */}
      <div className="w-full md:w-1/2 text-left">
        <p className="text-[#F36F21] font-bold text-sm mb-3">
          {title}
        </p>
        <h3 className="text-xl md:text-2xl font-bold text-[#101828] mb-4 leading-snug">
          {subTitle}
        </h3>
        <p className="text-[#475467] text-sm md:text-base leading-relaxed pr-0 md:pr-4">
          {content}
        </p>
      </div>

      {/* Kolom Kanan: Gambar */}
      <div className="w-full md:w-1/2 flex items-start md:items-start">
        {/* Background abu-abu muda membungkus gambar */}
        <div className="rounded-3xl px-6 md:px-8 w-full max-w-[640px] flex justify-center items-center">
          <img 
            src={srcImg} 
            alt={subTitle} 
            className="w-full h-auto object-contain drop-shadow-xl"
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className="bg-white min-h-screen  flex flex-col">
      <Navbar />
      <Banner
          image={process.env.REACT_APP_S3 + "banner_faq.png"} 
          beforePage="FAQ"
          currentPage="Detail FAQ" 
      />
      <div className="mx-auto px-4 md:px-24 w-full relative z-10 mb-16">
          <div className="rounded-2xl md:rounded-3xl">
              <div className="mb-10 md:mb-16 max-w-4xl">
                  <h1 className="text-2xl md:text-3xl lg:text-3xl font-bold text-[#101828] mb-6 leading-snug">
                      Apa keuntungan membayar tagihan di Summarecon Home Apps
                  </h1>
              </div>
              <div className="flex flex-col gap-12 md:gap-20">
                {renderContent(
                  "Keuntungan ke-1",
                  "Bayar Tagihan lebih cepat dan mudah",
                  "Tidak perlu lagi repot membayar tagihan secara manual, kamu bisa langsung lihat tagihan dan membayar tagihan dari banyak properti sekaligus di aplikasi Summarecon Home Apps",
                  DeailPayment1
                )}
                {renderContent(
                  "Keuntungan ke-2",
                  "Dapatkan 3 Premium Stamp setiap kamu membayar tagihan",
                  "Jika kamu Gold Member kamu bisa mendapat 3 Premium Stamp yang bisa ditukarkan ke berbagai keuntungan dan reward menarik di Summarecon Apps",
                  DeailPayment2
                )}
                {renderContent(
                  "Keuntungan ke-3",
                  "Lihat history tagihan pembayaranmu",
                  "Semua pembayaranmu akan tercatat di aplikasi sehingga kamu bisa dengan mudah mengecek status pembayaranmu. Baik pembayaran menggunakan aplikasi ataupun pembayaran diluar aplikasi",
                  DeailPayment3
                )}
                {renderContent(
                  "Keuntungan ke-4",
                  "Kamu bisa ikut program free IPL",
                  "Aplikasi Summarecon juga memiliki program free IPL. Setiap bulannya, pengguna beruntung yang rutin membayar IPL melalui aplikasi Summarecon akan mendapatkan potongan IPL",
                  DeailPayment4
                )}
              </div>
              <LastUpdate/>
          </div>
      </div>
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;